var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.14941 12.5C2.14941 12.0858 2.4852 11.75 2.89941 11.75H20.8994C21.3136 11.75 21.6494 12.0858 21.6494 12.5C21.6494 12.9142 21.3136 13.25 20.8994 13.25H2.89941C2.4852 13.25 2.14941 12.9142 2.14941 12.5Z",
    fill: "#F9B036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.42973 5.96967C9.72262 6.26256 9.72262 6.73744 9.42973 7.03033L3.96007 12.5L9.42973 17.9697C9.72262 18.2626 9.72262 18.7374 9.42973 19.0303C9.13683 19.3232 8.66196 19.3232 8.36907 19.0303L2.36908 13.0303C2.07619 12.7374 2.07619 12.2626 2.36908 11.9697L8.36907 5.96967C8.66196 5.67678 9.13683 5.67678 9.42973 5.96967Z",
    fill: "#F9B036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.9ff88b02107d7f3de068375c012592ed.svg";
export { ForwardRef as ReactComponent };